import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";

export function washData_buttonText(walkedNode) {

  supplyEventInAction(walkedNode)
}
